export default "__VITE_ASSET__z8bdXIH6__"